var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auction-grid"},[_vm._l((_vm.auctions),function(auction){return _c('AuctionCard',{key:auction.id,attrs:{"auction":auction},on:{"bid":_vm.onPlaceBid}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }